/**
 * Adds an event listener, returning a function that would remove event listener.
 * @param {Object|HTMLElement} target target element/object
 * @param {String} name event name
 * @param {Function} handler event handler
 * @param {Object} options options supported by addEventListener
 * @return {Function} cleanup function
 */
const addEventListener = (target, name, handler, options) => {
  target.addEventListener(name, handler, options);
  const removal = () => target.removeEventListener(name, handler, options);
  return removal;
};

export default addEventListener;
